// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1KKXf","footer":"ChangeClinic_footer__22gT8"};